import React from 'react'

export default function CurrencySuccess() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center px-8 py-12 max-w-sm">

        <div className="relative inline-flex items-center justify-center mb-7">
          <span className="absolute -top-3 -left-5 text-amber-400 text-sm">✦</span>
          <span className="absolute -top-4 -right-1 text-purple-400 text-xs">✦</span>
          <span className="absolute -bottom-2 -right-5 text-amber-400 text-sm">✦</span>
          <span className="absolute -bottom-3 -left-2 text-purple-400 text-xs">+</span>
          <span className="absolute top-1/2 -left-7 text-amber-400 text-xs -translate-y-1/2">+</span>

          <div className="w-16 h-16 rounded-full bg-white border-[6px] border-green-100 flex items-center justify-center">
            <div className="w-12 h-12 rounded-full bg-green-500 flex items-center justify-center">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2.5}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 12l4.5 4.5L19 7"
                />
              </svg>
            </div>
          </div>
        </div>

        <h2 className="text-xl font-bold text-indigo-900 leading-snug mb-2">
          Your Currency Converted<br />Successfully
        </h2>

        <p className="text-sm text-gray-400">Redirecting To Home....</p>
      </div>
    </div>
  );
}